import { useField } from "formik";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

interface SwitchFieldProps {
  name: string;
  label: string;
  hint?: string;
  /** Lock the toggle (e.g. a prerequisite isn't met). Also dims the label. */
  disabled?: boolean;
}

/**
 * Formik-bound labeled toggle row — label + hint on the left, shadcn {@link Switch}
 * on the right. Same boolean-field contract as {@link CheckboxField}, styled as the
 * full-width toggle row used on Settings › Integrations.
 */
export function SwitchField({ name, label, hint, disabled }: SwitchFieldProps) {
  const [field, , helpers] = useField({ name, type: "checkbox" });

  return (
    <div className={cn("flex items-start justify-between gap-3", disabled && "opacity-60")}>
      <div className="grid gap-0.5">
        <Label
          htmlFor={name}
          className={cn("font-semibold", disabled ? "cursor-not-allowed" : "cursor-pointer")}
        >
          {label}
        </Label>
        {hint && <p className="text-muted-foreground text-xs">{hint}</p>}
      </div>
      <Switch
        id={name}
        checked={!!field.value}
        disabled={disabled}
        onCheckedChange={(checked) => helpers.setValue(checked === true)}
        className="mt-0.5"
      />
    </div>
  );
}
